import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { toggleTheme } from '../../../redux/slices/themeSlice';
import styles from './ThemeToggle.module.scss';
import DarkIconActive from '../../../assets/images/dark_toggle_enabled.svg';
import LightIconActive from '../../../assets/images/light_toggle_enabled.svg';
import DarkIconInActive from '../../../assets/images/dark_toggle_disabled.svg';
import LightIconInActive from '../../../assets/images/light_toggle_disabled.svg';

type ThemeToggleProps = {
  isSidenav?: boolean;
  isExpanded?: boolean;
};
const ThemeToggle: React.FC<ThemeToggleProps> = ({ isSidenav = false, isExpanded }) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const dispatch = useAppDispatch();
  const applyTheme = (theme: 'light' | 'dark') => {
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    document.body.classList.remove('light', 'dark');
    document.body.classList.add('theme_provider', theme);
    document.documentElement.style.backgroundColor = theme === 'dark' ? '#000' : '#fff';
  };
  useEffect(() => {
    applyTheme(currentTheme);
  }, [currentTheme]);

  const handleToggle = () => {
    dispatch(toggleTheme());
  };
  useEffect(() => {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(currentTheme);
  }, [currentTheme]);

  return (
    <div
      className={`theme_switch_container 
        ${styles.theme_switch_container} 
        ${isSidenav ? styles.isSidenavToggle : ''} 
        ${!isExpanded && isSidenav ? styles.isNotExpanded : ''}`}
      onClick={handleToggle}
    >
      <div className={`${styles.slider} ${currentTheme === 'dark' ? styles.dark : styles.light}`} />
      <div className={styles.icon_wrapper}>
        <img
          src={currentTheme === 'light' ? LightIconActive : LightIconInActive}
          alt="Light"
          className={styles.icon}
        />
      </div>
      <div className={styles.icon_wrapper}>
        <img
          src={currentTheme === 'dark' ? DarkIconActive : DarkIconInActive}
          alt="Dark"
          className={styles.icon}
        />
      </div>
    </div>
  );
};

export default ThemeToggle;
